// Hermes domain error type. Framework-free: a single typed Error the whole
// domain throws so callers can branch on `.code` without string-matching
// messages. NEVER import anything but the standard library here.
//
// Known codes (the only ones the domain emits):
//   'illegal_transition' — Run state machine rejected a from→to edge
//   'children_pending'   — fan-out merge invariant: a child run is non-terminal
//   'invalid_agent'      — Agent aggregate failed construction validation
//   'invalid_run'        — Run aggregate failed construction validation
//   'invalid_value'      — a value object rejected its input

export class HermesDomainError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
    this.name = 'HermesDomainError';
  }
}
